<script setup>
import { computed, ref, watch } from "vue";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useValidation } from "@/utils/useValidataion";

const storeField = useFieldsStore();

const value = ref(null);

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
	type: {
		type: String,
		default: "text",
	},
	stateKey: {
		type: String,
	},
	placeholder: {
		type: String,
		default: "",
	},
	required: {
		type: Boolean,
		default: false,
	},
	minDate: {
		type: String,
		default: "1900-01-01",
	},
});

watch(
	() => storeField.fields[props.stateKey]?.title,
	(newVal) => {
        
		if (newVal !== value.value) {
			value.value = newVal ?? "";
		}
	},
	{ immediate: true }
);

function onInput(e) {
	const val = e.target.value;
	value.value = val;	
	if (props.stateKey) {
		storeField.updateFields(props.stateKey, "title", val);
	}
	validationInput(props.stateKey);
}

const validationInput = (stateKey) => {
	props.required ? validation(stateKey) : null;
};

const maxDate = computed(() => {
	const now = new Date();
	const maxYear = now.getFullYear();
	return `${maxYear}-12-31`;
});

</script>
<template>
	<label :class="['input']">
		<div class="input__holder">
			
			<input
				:type="type"
				:placeholder="placeholder"
				:required="required"
				:class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
				@input="onInput"
				@blur="validationInput(stateKey)"
				v-model="value"
				
                :min="props.minDate"
                :max="maxDate"
			/>
            <span class="input__title"><slot></slot></span>
		</div>
		<Transition mode="out-in">
			<span v-if="!!textError" class="input__error">{{ textError }}</span>
		</Transition>
	</label>
</template>
<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}
</style>
